<template>
    <div class="project">
        <advertising-figure :bannerSrc="bannerSrc"/>
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Meettingplace of the meeting</span>
            </public-title>

            <div class="divider">
                <h2 class="tit">会场介绍</h2>
                <span class="time">发布日期: 2022-1-15</span>
            </div>

            <div class="venue-wrap">
                <div class="venue">
                    <h2 class="tit">会场平面图</h2>
                    <div class="article-wrap">
                        <img src="@assets/img/venue.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";

export default {
    name: "VenuePage",
    components: {
        AdvertisingFigure,
        InnerPageNav,
        publicTitle,
    },

    data() {
        return {
            bannerSrc:require("@assets/img/meeting-banner.png"),
            title: "会场信息",
        };
    },

    methods: {},
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
        position: relative;
        font-size: 18px;
        color: #666;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 2px;
            background: $defaultColor;
        }
    }

    .time {
        font-size: 14px;
        color: #999;
    }
}

.venue-wrap {
    width: 1200px;
    margin: 0 auto;
}

.venue {
    padding: 30px;
    margin-bottom: 30px;
    min-height: 180px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    .tit {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        min-width: 180px;
        font-size: 20px;
        margin: 30px 0;
        color: $defaultColor;
        padding: 0 30px;
        text-align: center;

        &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: -100px;
            width: 100px;
            height: 2px;
            background: linear-gradient(to right, transparent, #ccc);
        }

        &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: -100px;
            width: 100px;
            height: 2px;
            background: linear-gradient(to left, transparent, #ccc);
        }
    }

    .article-wrap {
        text-align: center;
    }
}
</style>